<template lang="html">
  <section>
    <div v-if="!sendend">
      <h2 class="title title-36">{{ $t('contacto.titulo') }}</h2>
      <form @submit.prevent="validateBeforeSubmit" id="formContacto">

        <div class="select-style contenedor-input">
          <select v-model="form.tipo_contacto" v-validate="'required'" name="tipo_contacto">
            <option value="">{{ $t('formulario.motivo') }}*</option>
            <option :value="key" :key="key" v-for="(e, key) in $t('formulario.tipos_contacto')">{{ e }}</option>
          </select>
          <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('tipo_contacto')
          }}</span>
        </div>

        <div class="contenedor-input">
          <input type="text" class="input-text" v-model="form.nombre_apellidos" v-validate="'required'" name="nombre"
            :placeholder="$t('formulario.nombre_apellidos') + '*'" />
          <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('nombre') }}</span>
        </div>
        <div class="contenedor-input">
          <input type="text" class="input-text" v-model="form.empresa" name="empresa"
            :placeholder="$t('formulario.empresa')" />
        </div>
        <div class="contenedor-input">
          <input type="text" class="input-text" v-model="form.sector" name="sector"
            :placeholder="$t('formulario.sector')" />
        </div>

        <div class="contenedor-input">
          <input type="text" class="input-text" v-model="form.email" v-validate="'required|email'" name="email"
            :placeholder="$t('formulario.email') + '*'" />
          <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('email') }}</span>
        </div>



        <div v-if="showAsistencia">

          <div class="contenedor-input">
            <input type="text" class="input-text" v-model="form.referencia_producto" v-validate="'required'"
              name="referencia_producto" :placeholder="$t('formulario.referencia') + '*'" />
            <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('referencia_producto')
            }}</span>
          </div>

          <div class="input-file--container">
            <input type="file" @change="setFile" name="doc_adjunto" id="archivo_adjunto">
            <span>{{ archivo_adjunto }}</span>
          </div>


        </div>


        <div v-if="showCatalogo">

          <div class="select-style contenedor-input mt-10">
            <select v-model="form.tipo_catalogo" v-validate="'required'" name="tipo_catalogo">
              <option value="">{{ $t('formulario.tipo_catalogo') }}*</option>
              <option value="catalogo-general">{{ $t('enlaces.textos.catalogo_general') }}</option>
              <option value="catalago-de-turbos">{{ $t('enlaces.textos.catalogo_turbos') }}</option>
              <option value="catalago-juntas-de-compresor">{{ $t('enlaces.textos.catalogo_juntas_compresor') }}</option>
            </select>
            <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('tipo_catalogo')
            }}</span>
          </div>




          <div class="contenedor-input">
            <input type="text" class="input-text" v-model="form.direccion" v-validate="'required'" name="direccion"
              :placeholder="$t('formulario.direccion') + '*'" />
            <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('direccion') }}</span>
          </div>



        </div>

        <div class="contenedor-input">
          <input type="text" class="input-text" v-model="form.telefono" name="telefono"
            :placeholder="$t('formulario.telefono')" />
        </div>
        <div class="contenedor-input">
          <input type="text" class="input-text" v-model="form.pais" v-validate="'required'" name="pais"
            :placeholder="$t('formulario.pais') + '*'" />
          <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('pais') }}</span>
        </div>

        <div class="contenedor-input">
          <input type="text" class="input-text" v-model="form.ciudad" name="ciudad"
            :placeholder="$t('formulario.ciudad')" />
        </div>


        <div class="contenedor-input">
          <textarea :placeholder="$t('formulario.mensaje') + '*'" v-model="form.mensaje" name="mensaje"
            v-validate="'required'"></textarea>
          <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('mensaje') }}</span>
        </div>

        <popup-condiciones v-on:launch="showCondiciones" :error="errorCondiciones"></popup-condiciones>


        <div class="contenedor-check contenedor-input">
          <input id="politica" type="checkbox" v-model="form.politica" name="politica" v-validate="'required'" />
          <label for="politica">{{ $t('formulario.he_leido') }} <router-link target="_blank" :to="$t('enlaces.politica')">
              {{ $t('formulario.y_acepto') }}</router-link>.</label>
          <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('politica') }}</span>
        </div>

        <div class="contenedor-check">
          <input id="newsletter" type="checkbox" v-model="form.newsletter" name="newsletter" />
          <label for="newsletter">{{ $t('formulario.quiero_recibir') }}</label>
        </div>

        <input type="hidden" name="lang" :value="getLanguage">
        <button class="btn btn-dark -enviar -pink-full" :clicked="sending" :sendend="sendend"
          @click="eventGA('button-contact-form')">
          <div class="scroller">
            <span>{{ $t('formulario.enviar') }}</span>
            <span>
              <hollow-dots-spinner :animation-duration="1000" :dot-size="15" :dots-num="3" color="#054279" />
            </span>
            <span>{{ $t('formulario.enviado') }}</span>
          </div>

        </button>

      </form>
    </div>
    <div v-if="sendend">
      <thank-you-send-form />
    </div>
  </section>
</template>

<script lang="js">

import Vue from 'vue';
import VeeValidate from 'vee-validate';
import thankYouSendForm from '@/components/parts/thank-you-send-form'

Vue.use(VeeValidate);

import { mapGetters } from 'vuex';

import popupCondiciones from '@/components/parts/popup-condiciones'

import { HollowDotsSpinner } from 'epic-spinners'

export default {
  name: 'formulario',
  props: ['reason'],
  mounted() {
    if (this.reason === 'catalogo') {
      this.form.tipo_contacto = this.reason
    }
    this.form.lang = this.getLanguage;
    //this.archivo_adjunto = this.getTexts.formulario.archivo_adjunto;
  },
  components: {
    'popup-condiciones': popupCondiciones,
    HollowDotsSpinner,
    'thank-you-send-form': thankYouSendForm
  },
  data() {
    return {
      clicked: false,
      condiciones: false,
      sending: false,
      sendend: false,
      archivo_adjunto: '',
      form: {
        tipo_contacto: '',
        nombre_apellidos: '',
        email: '',
        telefono: '',
        mensaje: '',
        empresa: '',
        sector: '',
        ciudad: '',
        politica: false,
        newsletter: false,
        referencia_producto: '',
        tipo_catalogo: '',
        lang: '',

      }
    }
  },
  methods: {
    showCondiciones: function () {
      this.condiciones = true;
    },
    setFile: function (event) {
      this.archivo_adjunto = event.target.value;
    },
    validateBeforeSubmit: function () {
      this.clicked = true;
      this.$validator.validateAll().then(canSend => {
        (canSend) ? this.getFiles() : '';
      });
    },
    getFiles: function () {

      let filedata = new FormData(document.getElementById("formContacto"));

      let data = {
        filedata: filedata,
        form: this.form
      }

      this.send(data);
    },
    send: function (data) {

      let that = this;
      this.sending = true;

      $.ajax({
        url: `https://dmb.ajusa.online/api/contacto`,
        type: 'POST',
        data: data.filedata,
        cache: false,
        contentType: false,
        processData: false,
      })
        .done(function (r) {

          if (r.status) {
            for (let e in that.form) { that.form[e] = ''; }
            that.sending = true;
            that.clicked = false;
            that.sendend = true;
            that.$router.push({ name: 'contacto', params: { id: that.$t('enlaces.thank_you_page') } });
            that.eventGA('thank-you-page');
            that.scrollTo();
          }
        })
        .fail(function (error) {
          console.log(error);
        })
        .always(function () {
          console.log("complete");
        });
    },
    scrollTo() {
      $('body,html').animate({ scrollTop: 0 }, 800);
    }
  },
  computed: {
    showAsistencia: function () {
      let flag = false;

      if ((this.form.tipo_contacto == "asistencia_tecnica") || (this.$route.hash == "#reparacion")) {
        this.form.tipo_contacto = "asistencia_tecnica";
        flag = true;
      }

      return flag;
    },
    showCatalogo: function () {

      let flag = false;
      if ((this.form.tipo_contacto == "catalogo") || (this.$route.hash == "#catalogo")) {
        this.form.tipo_contacto = "catalogo";
        flag = true;
      }
      return flag;
    },
    errorCondiciones: function () {
      let flag = (!this.condiciones && this.clicked) ? true : false;
      return flag;
    },
    ...mapGetters(['getServer', 'getLanguage']),
  }
}
</script>

<style scoped>
.contenedor-input .error {
  bottom: -14px;
}


.select-style.contenedor-input .error {
  bottom: -24px;
}

.contenedor-check.contenedor-input {
  padding-bottom: 10px;
}

.btn.-enviar {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-top: 50px;
  max-width: 270px;
  height: 57px;
  padding: 0;
  outline: none;
  position: relative;
}


.btn[clicked="true"] .scroller {
  transform: translateY(-33.333333333%);
}

.btn[sendend="true"] .scroller {
  transform: translateY(-66.6666666666%);
}


.btn span {
  height: 57px;
  line-height: 57px;
  width: 100%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-align-items: center;
  align-items: center;
  width: 100%;
}

.btn span:last-of-type {
  background: #054279;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/view-parts/contacto-parts/formulario.vue